import { Button } from "@mui/material";
import { DeveloperRoute } from "../../types/route-helpers";
import { services, showMessage } from "../../types/services";
import { humanReadableMetric } from "./insights-page-utils";

interface MetricSelectorProps {
  readonly selectedMetric: string;
  readonly setSelectedMetric: (metric: any) => void;
  readonly mostRecentDelivery: string;
}

export default function MetricSelector({
  selectedMetric,
  setSelectedMetric,
  mostRecentDelivery,
}: MetricSelectorProps) {
  const testPython = () => {
    services.insightsService.testPython().then((response) => {
      showMessage(response.message, "success");
    });
  };
  return (
    <div className="insights-page-settings-box-1">
      <DeveloperRoute>
        <Button variant="contained" onClick={testPython}>
          Test Python
        </Button>
      </DeveloperRoute>
      {["bounceHeight", "slowDown", "deviation", "swing"].map((metric) => (
        <Button
          key={metric}
          onClick={() =>
            setSelectedMetric(
              metric as "bounceHeight" | "slowDown" | "deviation"
            )
          }
          variant={selectedMetric === metric ? "contained" : "outlined"}
        >
          {humanReadableMetric[metric]}
        </Button>
      ))}
      <div style={{ position: "absolute", right: 0, fontWeight: "bold" }}>
        {mostRecentDelivery}
      </div>
    </div>
  );
}
